import * as React from 'react';

const VolumeIcon = ({ isLowVolume = false, ...props }) => (
	<svg fill="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M13.5 4.06c0-1.34-1.62-2-2.56-1.06l-4.5 4.5H4.51c-1.14 0-2.32.66-2.66 1.9A9.76 9.76 0 001.5 12c0 .9.12 1.77.35 2.6.34 1.24 1.52 1.9 2.66 1.9h1.93l4.5 4.5c.94.94 2.56.28 2.56-1.06V4.06z" />
		{!isLowVolume ? (
			<path d="M19.07 5.07a.75.75 0 011.06 0 9.75 9.75 0 010 13.86.75.75 0 11-1.06-1.06 8.25 8.25 0 000-11.74.75.75 0 010-1.06z" />
		) : null}
		<path d="M15.93 7.76a.75.75 0 011.06 0 6 6 0 010 8.48.75.75 0 11-1.06-1.06 4.5 4.5 0 000-6.36.75.75 0 010-1.06z" />
	</svg>
);

export default VolumeIcon;
